module.exports = __webpack_public_path__ + "img/new-other-blue.f4954a68.svg";